import { isFunction } from "../../utils/zone.utils";
import { useQueryOriginSource } from "../layer/chain/useQueryOriginal";
import { convertToPropAccessByBracket, extractMethodArgument, extractMethodName, isFunctionByString, isMethodCalling } from "./util";


/**
    *
    * @param {string} expression
    * @param {object} props
    * @returns {any}
    */
export const runExtractValueOld = (props, str) => {
    if (!props) {
        return
    }
    try {
        const script = `
            'use strict';
            return props${convertToPropAccessByBracket(str)};`
        const fn = new Function('props', script),
            value = fn(props);
        if (value === undefined) {
            console.error(`${str} is undefined`)
        }
        return value;
    } catch (ex) {
        // console.error(ex, );
        throw `${ex.message} ${str}`;
    }
}


const extractIndexIfArray = (str) => {

}

/**
 * 
 * @param {object} props 
 * @param {Array<string>} params 
 */
const buildParams = (props, params) => {
    return params.map(name => {
        return runExtractValue(props, name);
    });
}

/**
    *
    * @param {string} expression
    * @param {object} props
    * @returns {any}
    */
export const runExtractValue = (props, str) => {
    if (!props) {
        return
    }
    const listKey = str.split('.');
    let latestKey = listKey.pop(), targetProps = props;
    try {
        while (listKey.length > 0) {
            targetProps = targetProps[listKey.shift()];
        }
        const originalSource = useQueryOriginSource(targetProps);
        if (targetProps[latestKey] !== undefined) {
            return targetProps[latestKey];
        } else if (targetProps[latestKey] !== undefined) {
            return Reflect.get(originalSource, latestKey);
        } else if (isMethodCalling(latestKey)) {
            const fnName = extractMethodName(latestKey);
            const paramByNames = extractMethodArgument(latestKey);
            let params = []
            if (paramByNames.length > 0) {
                params = buildParams(props, paramByNames);
            }
            return targetProps[fnName](...params);
        }
    }
    catch (ex) {
        console.log(ex)
    }
}


export const runUpdatePropValue = (props, str, value) => {
    const listKey = str.split('.');
    let latestKey = listKey.pop(), targetProps = props;
    try {
        while (listKey.length > 0) {
            targetProps = targetProps[listKey.shift()];
        }
        if (latestKey in targetProps) {
            targetProps[latestKey] = value;
        }
    } catch (ex) {
        console.log(ex)
    }
}